import {travelExplorerURL} from './apiDomain'
import {travelExplorerHttp} from './http'

export default {
    subscribe(data) {
        const client = travelExplorerHttp(travelExplorerURL);
        return client.post('/subscribe-newsletters', data)
    }
}
